export default __webpack_public_path__ + "static/media/CICA.95348465.svg";